import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Mail, Users, HandHelping, Heart, FileText, Image, BookOpen, Files } from "lucide-react";

const CARDS = [
    { key: "contact_enquiries", label: "Contact Enquiries", icon: Mail, link: "/admin/enquiries" },
    { key: "volunteer_enquiries", label: "Volunteer Enquiries", icon: Users, link: "/admin/enquiries" },
    { key: "csr_enquiries", label: "CSR Enquiries", icon: HandHelping, link: "/admin/enquiries" },
    { key: "donation_enquiries", label: "Donation Interest", icon: Heart, link: "/admin/enquiries" },
    { key: "blog_posts", label: "Blog / Media Posts", icon: FileText, link: "/admin/media" },
    { key: "gallery_items", label: "Gallery Items", icon: Image, link: "/admin/gallery" },
    { key: "programmes", label: "Programmes", icon: BookOpen, link: "/admin/programmes" },
    { key: "documents", label: "Documents", icon: Files, link: "/admin/documents" },
];

export default function Overview() {
    const [s, setS] = useState({});
    useEffect(() => { api.get("/admin/summary").then((r) => setS(r.data || {})); }, []);

    return (
        <div data-testid="admin-overview">
            <div className="flex items-end justify-between mb-8">
                <div>
                    <h1 className="text-2xl font-semibold text-slate-900">Overview</h1>
                    <p className="text-sm text-slate-500 mt-1">Everything happening on kabirfoundation.org.</p>
                </div>
                {s.unreviewed_total > 0 && (
                    <div className="text-sm px-3 py-1.5 rounded-full bg-amber-100 text-amber-800 font-semibold">
                        {s.unreviewed_total} unreviewed enquiries
                    </div>
                )}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {CARDS.map((c) => {
                    const Icon = c.icon;
                    return (
                        <Link
                            key={c.key}
                            to={c.link}
                            data-testid={`summary-${c.key}`}
                            className="bg-white border border-slate-200 rounded-lg p-5 hover:shadow-sm transition-shadow duration-200"
                        >
                            <div className="flex items-center justify-between mb-3">
                                <div className="text-xs uppercase tracking-[0.15em] text-slate-500 font-semibold">{c.label}</div>
                                <Icon size={18} className="text-slate-400" strokeWidth={1.5} />
                            </div>
                            <div className="text-3xl font-semibold text-slate-900">{s[c.key] ?? 0}</div>
                        </Link>
                    );
                })}
            </div>

            <div className="mt-10 grid md:grid-cols-2 gap-6">
                <div className="bg-white border border-slate-200 rounded-lg p-6">
                    <h2 className="font-semibold text-slate-900 mb-2">Quick actions</h2>
                    <p className="text-sm text-slate-500 mb-4">Common daily tasks.</p>
                    <div className="grid grid-cols-2 gap-3">
                        <Link to="/admin/media" className="px-4 py-3 rounded-md bg-slate-50 hover:bg-slate-100 text-sm font-medium">New blog post</Link>
                        <Link to="/admin/gallery" className="px-4 py-3 rounded-md bg-slate-50 hover:bg-slate-100 text-sm font-medium">Upload photos</Link>
                        <Link to="/admin/documents" className="px-4 py-3 rounded-md bg-slate-50 hover:bg-slate-100 text-sm font-medium">Add document</Link>
                        <Link to="/admin/impact" className="px-4 py-3 rounded-md bg-slate-50 hover:bg-slate-100 text-sm font-medium">Update impact</Link>
                    </div>
                </div>
                <div className="bg-white border border-slate-200 rounded-lg p-6">
                    <h2 className="font-semibold text-slate-900 mb-2">Team members</h2>
                    <p className="text-sm text-slate-500 mb-4">{s.team_members ?? 0} members on the About page.</p>
                    <Link to="/admin/team" className="text-brand-forest text-sm font-semibold">Manage team →</Link>
                </div>
            </div>
        </div>
    );
}
